<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="this.tablePath">付款管理列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <span slot="header">基本信息</span>
      <template slot="tools">
        <el-button v-if="!isReview"
                  size="mini"
                  type="primary"
                  @click="downloadPDF"
                  :loading="onDownloadDetail">生成PDF
        </el-button>
      </template>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="付款ID：">
              <span> {{id}} </span>
            </el-form-item>
            <el-form-item label="申请人："
                          prop="applicant_name">
              <span>{{form.applicant_name}} / {{form.applicant_real_name}}</span>
            </el-form-item>
            <el-form-item label="部门："
                          prop="department_name">
              <span>{{form.department_name}}</span>
            </el-form-item>
            <el-form-item label="付款类型："
                          prop="type">
              <span>{{type[form.type] || '批量付款'}}</span>
            </el-form-item>
            <el-form-item label="是否加急："
                          prop="is_urgent">
              <span>{{form.is_urgent ? '是' : '否'}}</span>
            </el-form-item>
            <el-form-item v-if="form.is_urgent === 1" label="期望日期："
                          prop="expected_date">
              <span>{{ form.expected_date | formatExpectedDate }}</span>
            </el-form-item>
            <el-form-item label="付款公司："
                          prop="payment_company">
              <span>{{paymentCompanys[form.payment_company]}}</span>
            </el-form-item>
            <el-form-item label="付款账户："
                          prop="payment_company" v-if="form.payment_company_account">
              <span>{{form.payment_company_account.name + '/' + form.payment_company_account.number}}</span>
            </el-form-item>
            <el-form-item label="付款说明："
                          prop="desc">
              <span>{{ form.desc }}</span>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel v-if="!isBatch">
      <span slot="header">付款信息</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item v-if="form.type" label="付款主体"
                          prop="paid_to_type">
              <span>{{form.paid_to_type === 1 ? '对私' : '对公'}}</span>
            </el-form-item>
            <el-form-item label="收款对象名称："
                          prop="company_name">
              <span>{{form.company_name}}</span>
            </el-form-item>
            <el-form-item label="银行账号："
                          prop="bank_account">
              <span>{{form.bank_account}}</span>
            </el-form-item>
            <el-form-item label="开户银行支行："
                          prop="bank">
              <span>{{form.bank}}</span>
            </el-form-item>
            <el-form-item label="开户银行总行："
                          prop="bank_headquarters">
              <span>{{form.bank_headquarters}}</span>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel>
      <span slot="header">费用信息</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <el-row :gutter="20" style="margin-left: 0px">
          <el-col :span="1" class="col-center">序号</el-col>
          <el-col :span="2" class="col-center">项目编号</el-col>
          <el-col :span="3" class="col-center">费用承担部门</el-col>
          <el-col :span="3" class="col-center">一级科目</el-col>
          <el-col :span="3" class="col-center">二级科目</el-col>
          <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">发票类型</el-col>
          <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">税率%</el-col>
          <el-col :span="2" class="col-center">应付金额</el-col>
          <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">发票张数</el-col>
          <el-col :span="2" class="col-center">摘要</el-col>
          <el-col v-if="[8,9,10].includes(form.status)" :span="2" class="col-center" style="color: red">*实付金额</el-col>
        </el-row>
        <br/>

        <el-row :gutter="20" v-for="(detailItem, itemIndex) in form.payment_detail"
                :key="itemIndex"
                class="invoice-row"
                style="margin-top:5px">
          <!--序号-->
          <el-col style="text-align: center" :span="1">
            {{itemIndex+1}}
          </el-col>
          <!-- 项目编号 -->
          <el-col key="project_id"
            :span="2">
            <span style="word-break: break-all;">{{detailItem.project_id > 0 ? (projectNames[detailItem.project_id] + '/' + detailItem.project_number) : '无'}}</span>
          </el-col>
          <!-- 费用承担部门 -->
          <el-col key="department_name"
            :span="3">
            <span>{{detailItem.department_name}}</span>
          </el-col>

          <!--一级科目-->
          <el-col :span="3">
            <!-- 会计审批通过后都可修改 -->
            <el-select v-if="[5, 6, 7].includes(form.status * 1) && isReview" v-model="detailItem.first_subject" @change="val => firstSubjectChange(val, itemIndex)">
              <el-option v-for="(label, value) in firstSubjects"
                        :key="value"
                        :label="label"
                        :value="Number(value)">
              </el-option>
            </el-select>
            <span v-else>{{detailItem.first_subject_name}}</span>
          </el-col>
          <!--二级科目-->
          <el-col :span="3">
             <!-- 会计审批通过后都可修改 -->
            <el-select v-if="[5, 6, 7].includes(form.status * 1) && isReview" v-model="detailItem.second_subject">
              <el-option v-for="(label, value) in secondSubjects[itemIndex]"
                        :key="value"
                        :label="label"
                        :value="Number(value)">
              </el-option>
            </el-select>
            <span v-else>{{detailItem.second_subject_name}}</span>
          </el-col>
          <!--发票类型-->
          <el-col v-if="showFeesInfoFileds" :span="2">
            <span>{{invoiceType[detailItem.invoice_type]}}</span>
          </el-col>
          <!--税率-->
          <el-col v-if="showFeesInfoFileds" :span="2" style="text-align:center;overflow: auto;">
            <span>{{ detailItem.invoice_type === 1 ? '-' : (taxRateType[detailItem.tax_rate] || (detailItem.tax_rate + '%')) }}</span>
          </el-col>
          <!--含税金额-->
          <el-col :span="2" style="text-align:center;overflow: auto;">
            <span>￥{{detailItem.amount | seperateThousandsToFixed(2)}}</span>
          </el-col>
          <!--发票张数-->
          <el-col v-if="showFeesInfoFileds" :span="2">
            <span>{{detailItem.invoice_count}}</span>
          </el-col>
          <!--摘要-->
          <el-col :span="2">
            <span style="word-break: break-all;">{{detailItem.desc}}</span>
          </el-col>
          <el-col v-if="[8,9,10].includes(form.status)" :span="2">
            <span>{{detailItem.paid_amount}}</span>
          </el-col>
        </el-row>
        <br/>
        <el-row class="invoice-row" :gutter="20">
          <el-col :span="spanWithType">
            <p style="padding: 0; margin:0; text-align: right;">付款金额合计：</p>
          </el-col>
          <el-col :span="2">
            ￥{{totalAmount | seperateThousandsToFixed(2)}}
          </el-col>
          <el-col v-if="showFeesInfoFileds" :span="2">
            {{totalInvoiceCount}}
          </el-col>
          <el-col v-if="[8,9,10].includes(form.status)" :span="2">
            <p style="padding: 0; margin:0; text-align: right;color: red;">实付金额合计：</p>
          </el-col>
          <el-col v-if="[8,9,10].includes(form.status)" :span="2" style="color: red">
            ￥{{totalPaidAmount | seperateThousandsToFixed(2)}}
          </el-col>
        </el-row>

        <el-form-item label="附件"
                      prop="attached_file">
          <AttachedFileContent :files="form.attached_file"/>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <span slot="header">审批人</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium" style="width: 100%">
            <el-form-item label="部门领导审批："
                          prop="department_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.department_approver_name}/${form.department_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <!-- approve_level -->
                  <span v-if="![11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="form.approve_level > 0" label="一级审批："
                          prop="first_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.first_approver_name}/${form.first_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <!-- approve_level -->
                  <span v-if="![1,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="form.approve_level > 1" label="二级审批："
                          prop="second_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.second_approver_name}/${form.second_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <span v-if="![1,2,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="form.approve_level > 2" label="三级审批："
                          prop="third_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.third_approver_name}/${form.third_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <span v-if="![1,2,3,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="form.approve_level > 3" label="四级审批："
                          prop="fourth_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.fourth_approver_name}/${form.fourth_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <span v-if="![1,2,3,4,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="form.is_urgent && form.special_approver" label="特批审批："
                          prop="fourth_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.special_approver_name}/${form.special_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <span v-if="![1,2,3,4,11,12,13,14].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="抄送人："
                          prop="cc">
              <el-row :gutter="20">
                <el-col :span="20">
                  <span style="white-space:pre-wrap; word-wrap: break-word;">{{form.cc_name}}</span>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>
    <layout-panel>
      <span slot="header">付款信息</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium" style="width: 100%">
            <el-form-item label="付款状态："
                          prop="status">
              <span>{{status[form.status]}}</span>
            </el-form-item>
            <el-form-item label="实付金额合计："
                          prop="paid_amount_total">
              <span>{{form.paid_amount_total}}</span>
            </el-form-item>
            <el-form-item label="日志："
                          prop="log">
              <span style="white-space:pre-wrap;">{{form.log}}</span>
            </el-form-item>
            <el-form-item label="付款结果附件："
                          v-if="[8, 9, 10].includes(form.status * 1)"
                          prop="paid_attached_file">
              <AttachedFileContent :files="form.paid_attached_file"/>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <!-- 冲销信息 -->
    <template v-if="[8,10].includes(form.status) && isPrepaymentType">
      <PaymentWriteOffInfo
        :form="form"
        :projectNames="projectNames"/>
    </template>

    <!-- 新增冲销 / 修改冲销  -->
    <template v-if="!isReview">
      <PaymentWriteOffForm
        :title="isUpdate ? '修改冲销' : '新增冲销'"
        v-if="showWriteOffForm"
        :id="id"
        :model="writeOffForm"
        :projectNames="projectNames"
        :originSecondSubjects="originSecondSubjects"
        :writeOffAssociatedRelationships="writeOffAssociatedRelationships"
        :originFirstSubjects="originFirstSubjects"
        :writeOffSecondSubjects="writeOffSecondSubjects"/>

      <!-- 审批人 -->
      <PaymentApproverForm
        :onlyShowCC="form.paid_to_type === 2"
        :form="writeOffForm"
        :totalAmount="writeOffForm.amount"
        :approverBoundaryValues="approverBoundaryValues"/>

      <el-button type="primary" @click="onWriteOffSubmit">提交表单</el-button>
      <el-button @click="$router.back()">返回</el-button>
    </template>

    <!-- 审核冲销信息 -->
    <template v-if="isReview">
      <PaymentWriteOffReview
        v-if="showWriteOffForm"
        :model="writeOffForm"
        :projectNames="projectNames"/>

    </template>
  </div>
</template>

<script>
import moment from 'moment'

import { formRules, writeOffFormRules } from '../payment-manager.rules.js'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'

import AttachedFileContent from '@/views/payment-manager-new/components/AttachedFileContent'

import PaymentWriteOffInfo from '../components/PaymentWriteOffInfo'
import PaymentWriteOffForm from '../components/PaymentWriteOffForm'
import PaymentApproverForm from '../components/PaymentApproverForm'
import PaymentWriteOffReview from '../components/PaymentWriteOffReview'

export default {
  components: {
    AttachedFileContent,
    PaymentApproverForm,
    PaymentWriteOffForm,
    PaymentWriteOffReview,
    PaymentWriteOffInfo,
  },
  filters: {
    formatExpectedDate (date) {
      if (moment(date).isValid()) {
        return moment(date).format('YYYY-MM-DD')
      }
      return ''
    },
  },
  data () {
    return {
      id: 0,
      formRules,
      writeOffFormRules,
      onDownloadDetail: false,
      fileList: [],
      userDetail: {},
      form: {
        approve_level: null,
        applicant_name: '',
        applicant_real_name: '',
        department_id: null,
        department_name: null,
        bank_account_snapshot: {
          name: null,
          bank_account: null,
          bank: null,
          bank_headquarters: null,
          remark: null,
        },
        desc: null,
        type: null,
        status: null,
        is_urgent: 0,
        payment_company: null,
        payment_company_account: {
          id: 0,
          name: '',
          number: ''
        },
        paid_to_type: 0,
        user_bank_account_id: '', // 对私付款，用户账户信息 id
        company_bank_account_id: '', // 对公付款，公司账户信息 id，为0时创建新的对公付款账户信息
        company_name: null,
        bank_account: null,
        bank: null,
        bank_headquarters: null,
        current_approver: null,
        department_approver: null,
        department_approver_name: null,
        department_approver_real_name: null,
        first_approver: null,
        first_approver_name: null,
        first_approver_real_name: null,
        second_approver: null,
        second_approver_name: null,
        second_approver_real_name: null,
        third_approver: null,
        third_approver_name: null,
        third_approver_real_name: null,
        fourth_approver: null,
        fourth_approver_name: null,
        fourth_approver_real_name: null,
        special_approver: null,
        special_approver_name: null,
        special_approver_real_name: null,
        cc: null,
        cc_name: null,
        expected_date: '',
        apply_amount: null,
        paid_amount_total: null,
        payment_detail: [{
          project_id: null,
          project_number: null,
          department_id: null,
          department_name: null,
          first_subject: null,
          second_subject: null,
          invoice_type: null,
          tax_rate: null,
          amount: null,
          invoice_count: null,
          desc: null,
          paid_amount: null,
        }],
        attached_file: [],
        paid_attached_file: [],
        log: null,
        write_off_lists: [],

        // 退款
        refund_amount_total: null,
        refund_detail: [],
        refund_log: null,

        // 冲销
        written_off_amount: null,
      },
      firstSubjects: {},
      secondSubjects: [{}],
      writeOffSecondSubjects: [{}],
      projectNames: {},
      first_approver: null,
      second_approver: null,
      third_approver: null,
      fourth_approver: null,
      reason: null,
      paid_date: null,
      // 冲销
      writeOffForm: {
        attached_file: [],
        amount: null,
        write_off_detail: [{
          id: null,
          project_id: null,
          project_number: null,
          department_id: null,
          first_subject: null,
          second_subject: null,
          invoice_type: null,
          tax_rate: null,
          amount: null,
          invoice_count: null,
          desc: null,
          canSelectDepartment: true,
        }],
        desc: null,

        is_urgent: 0,
        department_approver: null,
        first_approver: null,
        second_approver: null,
        third_approver: null,
        fourth_approver: null,
        // special_approver: null,
        cc: null,

      },
      dateTimePickerRangeOptions: {
        disabledDate: function (time) {
          return time.getTime() > Date.now()
        },
      },
      selectItem: {},

      originFirstSubjects: null,
      originSecondSubjects: null,
      associatedRelationships: null,
      writeOffAssociatedRelationships: null,

      canGoReview: false,
      paymentCompanys: {},

      approverBoundaryValues: {
        approve_amount_lv1: 0,
        approve_amount_lv2: 2000,
        approve_amount_lv3: 10000,
        approve_amount_lv4: 50000,
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
      type: state => state.paymentManagerNew.type,
      status: state => state.paymentManagerNew.status,
      invoiceType: state => state.paymentManagerNew.invoiceType,
      taxRateType: state => state.paymentManagerNew.taxRateType,
    }),
    totalAmount () {
      return this.form.payment_detail.reduce((total, item) => {
        return total + Number(item.amount)
      }, 0)
    },
    totalInvoiceCount () {
      return this.form.payment_detail.reduce((total, item) => {
        return total + Number(item.invoice_count)
      }, 0)
    },
    totalPaidAmount () {
      return this.form.payment_detail.reduce((total, item) => {
        return total + Number(item.paid_amount)
      }, 0)
    },
    spanWithType () {
      if (this.isBatch) {
        return 10
      } else {
        if (this.isPrepaymentType) {
          return 9
        }
      }
      return 14
    },
    showFeesInfoFileds () {
      if (this.isBatch) {
        return false
      } else {
        return !this.isPrepaymentType
      }
    },
    isBatch () {
      return this.form.type === 4
    },
    isUpdate () {
      return this.$route.meta.isUpdate
    },
    isReview () {
      return this.$route.meta.isReview
    },
    showWriteOffForm () {
      return this.form.status > 0
    },
    isPrepaymentType () {
      return this.form.type === 3
    },
    tablePath () {
      if (this.$route.query.from && this.$route.query.from === 'approval') {
        return '/payment-manager-new/approval'
      } else {
        if (this.$route.meta.isApproval) {
          return '/payment-approval/table'
        }
        return '/payment-manager-new/table'
      }
    }
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {
  },
  mounted () {},
  methods: {
    ...request.map([
      'getProjectTable',
      'getProjectDetail',
      'getPlatformUsersIndex',
      'getPlatformUsersDetail',
    ]),
    async onLoad () {
      await this.getFinCenterConfigs()
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      } else {
        this.fetchUserDetail('getuserAccountDetailByUserID', {id: this.user.id})
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getPaymentManagerDetail', {id}).then(async ({data}) => {
        await this.setupProjectNames(data)
        filter.setLoop(this.form, data)

        this.form.paid_attached_file = data.paid_attached_file || []
        this.setupLog(data)
        this.setupSubjects(data)
        this.fetchPlatformUsersWithCCids(data)
        this.setupOtherData(data)
        this.setupWriteOffDetail(data)

        this.setupCanGoReview(data)
      })
    },
    setupCanGoReview (data) {
      if (this.$route.meta.isApproval) { // 财务管理进入查看详情
        if ([5, 6].includes(data.status)) {
          // 当前用户为 超管/财务管理员， usertype == 1 或者 usertype ==5
          if (this.user.usertype * 1 === 1) {
            this.canGoReview = true
          } else if (this.user.usertype * 1 === 5) { // 财务管理员 需要校验权限
            const params = {
              id: this.id,
              is_test_permission: 1
            }
            let uri = 'accountantReviewPaymentApplication'
            if ([6].includes(data.status)) {
              uri = 'managerReviewPaymentApplication'
            }
            request.loading(uri, params).then(res => {
              this.canGoReview = true
            }).catch((_) => {
              this.canGoReview = false
            })
          }
        }
      } else { // 客户管理进入
        if ([1, 2, 3, 4, 13, 14].includes(data.status)) {
          // 当前用户为 超管 或者 current_approver = 当前用户id
          this.canGoReview = (this.user.usertype * 1 === 1) || (data.current_approver === this.user.id * 1)
        }
      }
    },
    setupLog (data) {
      this.form.log = data.log.reduce((total, item) => {
        return total + `${item.created_at} ${item.admin_name}/${item.admin_real_name || '-'} ${item.desc}\n`
      }, '')
    },
    setupSubjects (data) {
      const firstSubjectIds = this.associatedRelationships[this.form.type]
      const firstSubjects = {}
      for (const id in firstSubjectIds) {
        firstSubjects[id] = this.originFirstSubjects[id]
      }
      this.firstSubjects = firstSubjects

      data.payment_detail.forEach((item, index) => {
        const secondSubjects = {}
        const secondSubjectIds = firstSubjectIds[item.first_subject]
        for (const index in secondSubjectIds) {
          const id = secondSubjectIds[index]
          secondSubjects[id] = this.originSecondSubjects[id]
        }
        this.secondSubjects[index] = secondSubjects

        // 当一级科目被禁用的时候，需要重置为 null
        if (!this.firstSubjects[item.first_subject]) {
          item.first_subject = null
        }

        // 当二级科目被禁用的时候，需要重置为 null
        if (!secondSubjects[item.second_subject]) {
          item.second_subject = null
        }
      })
    },
    setupProjectNames (data) {
      let reqProjectApis = []
      this.projectNames = {
        '0': '无'
      }
      data.payment_detail.forEach((item, index) => {
        item.project_id = item.project_id + ''
        reqProjectApis.push(item.project_id)
      })
      data.write_off_lists.forEach(writeOff => {
        writeOff.write_off_detail.forEach((item, index) => {
          item.project_id = item.project_id + ''
          reqProjectApis.push(item.project_id)
        })
      })
      reqProjectApis = _.uniq(reqProjectApis)
      reqProjectApis = reqProjectApis.filter(item => item > 0).map(id => request('getProjectDetail', {id: id}))
      return request.all.common(reqProjectApis).then(res => {
        res.map(item => {
          if (item.data.name && item.data.number) {
            this.projectNames[item.data.id] = item.data.name
            // return item.data.name + '/' + item.data.number
          }
          // return '无'
        })
      })
    },
    fetchPlatformUsersWithCCids (data) {
      if (data.cc.length > 0) {
        const adminuserIds = [...data.cc]
        const ccNames = []
        request.common('fetchApproverRealName', {user_id: adminuserIds}).then((res) => {
          res.data.forEach(item => {
            ccNames.push(`${item.user_name}/${item.name || '-'}`)
          })
          this.form.cc_name = ccNames.join('\t')
        })
      } else {
        this.form.cc_name = '无'
      }
    },
    setupOtherData (data) {
      if (data.paid_to_type === 1) {
        this.fetchUserDetail('getUserBankAccountById', {id: data.user_bank_account_id})
      }
      if ([8, 10].includes(data.status)) {
        // this.form.write_off = data.write_off_lists.reduce((total, item) => {
        //   return total + Number(item.amount)
        // }, 0)
        this.form.wait_write_off = this.form.paid_amount_total - this.form.written_off_amount
      }
      if (this.form.paid_to_type === 2) {
        this.getCompanyAccountsDetail(data)
        // this.getCompanyAccountsDetail({id: this.form.company_bank_account_id})
      }
    },
    setupWriteOffDetail (data) {
      if (this.isReview || this.isUpdate) {
        data = this.getWriteoffDataInReviewOrUpdate(data)
      } else {
        // 新增冲销数据
        data.list = data.payment_detail.map(item => {
          item.payment_detail_id = item.id
          return item
        })
      }
      this.setupWriteOffApproverData(data)
      data.list.forEach((item, index) => {
        if (this.writeOffForm.write_off_detail.length === index) {
          this.addDetailItem()
        }
        this.writeOffFirstSubjectChange(item.first_subject, index)
        this.setupWriteOffDetailAt(item, index)
      })
    },
    // 获取 编辑 、审核过程中的  writeOffData
    getWriteoffDataInReviewOrUpdate (data) {
      const status = this.isReview ? [1, 2, 3, 4, 5] : [9] // 财务 [6,7]  // 冲销成功 [8]
      const detail = data.write_off_lists.find(item => status.includes(item.status))
      // 冲销审核过程中 过滤掉 amount 为 0 的冲销数据
      detail.list = this.isReview ? detail.write_off_detail.filter(item => !item.is_zero_apply) : detail.write_off_detail

      this.writeOffForm.id = detail.id
      this.writeOffForm.desc = detail.desc
      this.writeOffForm.attached_file = detail.attached_file
      this.writeOffForm.log = detail.log
      return detail
    },
    setupWriteOffApproverData (data) {
      this.writeOffForm.department_approver = data.department_approver
      this.writeOffForm.first_approver = data.first_approver
      this.writeOffForm.second_approver = data.second_approver
      this.writeOffForm.third_approver = data.third_approver
      this.writeOffForm.fourth_approver = data.fourth_approver
      this.writeOffForm.cc = data.cc
    },
    setupWriteOffDetailAt (item, index) {
      const writeOffDetail = this.writeOffForm.write_off_detail[index]
      writeOffDetail.payment_detail_id = item.payment_detail_id
      writeOffDetail.id = item.id
      writeOffDetail.project_id = item.project_id
      writeOffDetail.project_name = item.project_id > 0 ? this.projectNames[item.project_id] : ''
      writeOffDetail.project_number = item.project_number
      writeOffDetail.department_id = item.department_id
      writeOffDetail.department_name = item.department_name
      writeOffDetail.first_subject = item.first_subject
      writeOffDetail.second_subject = item.second_subject
      writeOffDetail.amount = item.paid_amount
      writeOffDetail.desc = item.desc
      if (item.project_number && Number(item.project_id)) {
        if (item.project_number[0] === 'H') {
          writeOffDetail.canSelectDepartment = true
        } else {
          writeOffDetail.canSelectDepartment = false
        }
      } else {
        writeOffDetail.canSelectDepartment = true
      }
      if (parseInt(item.project_id) === 0) {
        writeOffDetail.project_id = null
      }
      if (parseInt(item.department_id) === 0) {
        writeOffDetail.department_id = null
      }
      if (this.isReview || this.isUpdate) {
        writeOffDetail.first_subject_name = item.first_subject_name
        writeOffDetail.second_subject_name = item.second_subject_name
        writeOffDetail.invoice_type_name = item.invoice_type_name
        writeOffDetail.invoice_count = item.invoice_count
        writeOffDetail.invoice_type = item.invoice_type
        writeOffDetail.tax_rate = item.tax_rate

        // 从 write_off_detail 中的 write_off_lists 获取 amout
        // 解决 836 行的问题 paid_amount 不存在的问题
        writeOffDetail.amount = item.amount
      }
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    getWriteOffForm () {
      const writeOffForm = filter.copyJson(this.writeOffForm)
      writeOffForm.write_off_detail.forEach(item => {
        item.department_id = item.department_id || 0
        if (item.invoice_type === 1) { // 普通票
          item.tax_rate = 0
        }
        item.project_number = item.project_number || ''
        item.project_id = item.project_id || 0
        item.department_id = item.department_id || 0
        // if ([3, 4].includes(form.type)) { // 批量付款申请 或 预付款
        //   item.invoice_type = 0
        //   item.tax_rate = 0
        //   item.invoice_count = 0
        // }
      })
      return writeOffForm
    },
    checkPaymentDetail () {
      if (!this.writeOffForm.desc) {
        this.$message.error('请填写核销说明')
        return false
      }
      let list = this.writeOffForm.write_off_detail
      let rule = {
        first_subject: '一级科目',
        second_subject: '二级科目',
        amount: '含税金额',
        desc: '摘要',
      }
      for (let i = 0; i < list.length; i++) {
        for (const ruleKey in rule) {
          if (!list[i][ruleKey]) {
            this.$message.error(rule[ruleKey] + '不能为空！')
            return false
          }
        }
        if (list[i].tax_rate > 100 || list[i].tax_rate < 0) {
          this.$message.error('请输入正确的税率,范围0 ~ 100！')
          return false
        }
        let projectNumberFirstChart = ''
        if (list[i].project_number && typeof list[i].project_number === 'string') {
          projectNumberFirstChart = list[i].project_number.substr(0, 1)
        }
        if (projectNumberFirstChart === 'H' || !list[i].project_number) { // 项目编号首字母为H或者无编号
          if (!list[i].department_id) {
            this.$message.error('请选择费用承担部门！')
            return false
          }
        }
        if (!list[i].invoice_count && !this.isBatch && !this.isPrepaymentType) {
          this.$message.error('请填写发票张数')
          return false
        }
      }
      return true
    },
    onWriteOffSubmit () {
      if (this.writeOffForm.amount > this.form.wait_write_off) {
        this.$message.error('冲销金额不得大于该付款申请的待冲销金额')
        return
      }
      if (this.checkPaymentDetail()) {
        if (this.isUpdate) {
          this.updateWriteOffApplication(this.id)
        } else {
          this.writeOffApplication(this.id)
        }
      }
    },
    updateWriteOffApplication (id) {
      request.common('updatePaymentWriteOffData', {payment_apply_id: id, ...this.getWriteOffForm()}).then((res) => {
        this.$alert('修改冲销成功', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: this.tablePath})
        })
      })
    },
    writeOffApplication (id) {
      request.common('createPaymentWriteOffData', {payment_apply_id: id, ...this.getWriteOffForm()}).then((res) => {
        this.$alert('新增冲销添加成功', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: this.tablePath})
        })
      })
    },
    fetchUserDetail (uri, params) {
      request.common(uri, params).then(({data}) => {
        if (this.$route.params.id) {
          if (this.form.paid_to_type === 1) {
            this.form.user_bank_account_id = data.id
            this.form.company_name = data.name
            this.form.bank_account = data.bank_account
            this.form.bank = data.bank
            this.form.bank_headquarters = data.bank_headquarters
          }
        } else {
          this.form.department_id = data.id
          this.userDetail = data
          this.form.first_approver = data.first_approver
          this.form.second_approver = data.second_approver
          this.form.third_approver = data.third_approver
          this.form.fourth_approver = data.fourth_approver
        }
      })
    },
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        this.setupApproverLevel(data)
        this.setupSubjectsFromFinCenterConfigs(data)
        this.setupPaymentCompany(data)
      })
    },
    setupApproverLevel (data) {
      this.approverBoundaryValues.approve_amount_lv1 = data.approve_amount_lv1 || this.approverBoundaryValues.approve_amount_lv1
      this.approverBoundaryValues.approve_amount_lv2 = data.approve_amount_lv2 || this.approverBoundaryValues.approve_amount_lv2
      this.approverBoundaryValues.approve_amount_lv3 = data.approve_amount_lv3 || this.approverBoundaryValues.approve_amount_lv3
      this.approverBoundaryValues.approve_amount_lv4 = data.approve_amount_lv4 || this.approverBoundaryValues.approve_amount_lv4
    },
    setupSubjectsFromFinCenterConfigs (data) {
      this.originFirstSubjects = this.expandData(_.values(data.first_subject_source))
      this.originSecondSubjects = this.expandData(_.values(data.second_subject_source))
      this.associatedRelationships = data.payment_apply_subject_map
      this.writeOffAssociatedRelationships = data.payment_write_off_subject_map
    },
    setupPaymentCompany (data) {
      this.paymentCompanys = data.payment_apply_our_company_source.reduce((o, k) => {
        o[k.id] = k.name
        return o
      }, {})
    },
    expandData (data) {
      // data = data.filter(item => { return item.is_disabled < 1 })
      let result = {}
      for (const dataKey in data) {
        const tmp = data[dataKey]
        result[tmp.id] = tmp.name
      }
      return result
    },
    getCompanyAccounts (key) {
      return request.common('getCompanyBankAccountTable', {company_name: key.keyword})
    },
    getCompanyAccountsDetail (data) {
      // request.common('getCompanyBankAccountById', id).then(data => {
      this.form.company_name = data.bank_account_snapshot.company_name
      this.form.bank_account = data.bank_account_snapshot.bank_account
      this.form.bank = data.bank_account_snapshot.bank
      this.form.bank_headquarters = data.bank_account_snapshot.bank_headquarters
      // })
    },
    addDetailItem () {
      this.writeOffForm.write_off_detail.push(
        {
          project_id: null,
          project_number: null,
          department_id: null,
          first_subject: null,
          second_subject: null,
          invoice_type: null,
          tax_rate: null,
          amount: null,
          invoice_count: null,
          desc: null,
        }
      )
      this.secondSubjects.push({})
    },
    downloadPDF () {
      this.onDownloadDetail = true
      downloadJS(request.items.exportPaymentApplicationPDF({id: this.id}), false, false, {
        'SJ-Auth-Token': getToken()
      }, () => {
        this.onDownloadDetail = false
      })
    },
    firstSubjectChange (val, index) {
      this.form.payment_detail[index].second_subject = null
      const secondSubjects = {}
      const secondSubjectIds = this.associatedRelationships[this.form.type][val]
      for (const index in secondSubjectIds) {
        const id = secondSubjectIds[index]
        secondSubjects[id] = this.originSecondSubjects[id]
      }
      this.secondSubjects[index] = secondSubjects
    },
    handleExceed (files, fileList, max) {
      this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList, formField) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        formField.splice(index, 1)
      }
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    onChangeFile (file, fileList, formField) {
      let isLt5M = file.raw.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('文件内容必须小于5MB!')
        this.$refs.upload.uploadFiles.pop()
        return false
      }
      this.onUploadFile(file.raw, fileList, formField)
    },
    onUploadFile (file, fileList, formField) {
      let formData = new FormData()
      formData.append('file', file)
      this.id && formData.append('apply_id', this.id)
      return request.alert('finCenterUploadPaymentApplyFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type = file.name.split('.').pop().toLowerCase()
        if (['jpeg', 'jpg', 'png'].includes(type)) {
          type = 'pic'
        } else if (['pdf'].includes(type)) {
          type = 'pdf'
        } else if (['eml', 'html', 'htm'].includes(type)) {
          type = 'eml'
        } else if (['xlsx', 'doc', 'docx'].includes(type)) {
          type = 'office'
        }
        if (index > -1) {
          formField[index] = {name: file.name, url: data, type: type}
        }
      }).catch(_ => {
        this.$refs.upload.uploadFiles.pop()
      })
    },
    writeOffFirstSubjectChange (val, index) {
      this.writeOffForm.write_off_detail[index].second_subject = null
      const secondSubjects = {}
      const secondSubjectIds = this.writeOffAssociatedRelationships[val]
      for (const index in secondSubjectIds) {
        const id = secondSubjectIds[index]
        secondSubjects[id] = this.originSecondSubjects[id]
      }
      this.writeOffSecondSubjects[index] = secondSubjects
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.col-center {
  text-align:center
}
.invoice-row .el-col {
  line-height: 30px;
  text-align: center;
}

.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;

  ul {
    transform: translateX(0px);
    transition: all 0.3s;
    box-sizing: content-box;
    // height: 100px;
    overflow: hidden;
    padding: 1px 0;

    li {
      float: left;
      list-style: none;
      width: 100px;
      height: 100px;
      margin-right: 5px;
      cursor: pointer;
      font-size: 0;
      line-height: 0;
      overflow: hidden;
      transition: opacity 0.15s;
    }
  }
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/payment-manager-new/pages/PaymentManagerWriteOff.vue